import React from 'react'
import { Row, Col, Label, ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import ErrorBoundary from '@/components/ErrorBoundary'
import LoadingIndicator from '@/components/LoadingIndicator'
import { ValidationBoundary, Validator, ValidationState } from '@/components/validation'
import Resx from '@/components/Resx'
import { localized } from '@/decorators/localized'
import { DropDownList } from '@/components/dropDownList'
import context from '@/context'

@localized()
class SelectReportTemplateCategoryDialog extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = { ...props.reportTemplate }
  }
  renderBody () {
    if (this.props.loading) { return <LoadingIndicator /> }
    return (
      <React.Fragment>
        <Row>
          <Col lg='6'>
            <Label><Resx name='Common.Code' />: </Label>
            <span className='ml-2'>{this.state.code}</span>
          </Col>
        </Row>
        <Row>
          <Col lg='6'>
            <Label><Resx name='Common.Name' />: </Label>
            <span className='ml-2'>{this.state.reportTemplateVersionName}</span>
          </Col>
        </Row>
        <Row>
          <Col lg='6'>
            <Label><Resx name='Common.LatinName' />: </Label>
            <span className='ml-2'>{this.state.reportTemplateVersionLatinName}</span>
          </Col>
        </Row>
        <Row>
          <Col><hr /></Col>
        </Row>
        <Row>
          <Col>
            <Label><Resx name='Reporting.ReportTemplateCategoryName' />:</Label>
            <Validator name='reportTemplateCategory' value={this.state.reportTemplateCategory} required>
              <DropDownList
                value={this.state.reportTemplateCategory}
                dataSource={context.api.reportTemplateService.getCategories}
                onChange={x => this.setState({ reportTemplateCategory: x.item })}
              />
            </Validator>
          </Col>
        </Row>
      </React.Fragment>
    )
  }
  render () {
    const { loading, updating } = this.props
    const icon = updating ? 'loader bx-spin' : 'save'
    return (
      <ValidationBoundary>
        <BasicHeader title='' {...this.props} />
        <ModalBody>
          <ErrorBoundary>
            {this.renderBody()}
          </ErrorBoundary>
        </ModalBody>
        <ValidationState render={({ isValid }) =>
          <ConfirmFooter primaryButtonText='Common.SaveAndClose' icon={icon} {...this.props} onAction={() => this.props.onAction(this.state)} disabled={!isValid || loading || updating} />
        } />
      </ValidationBoundary>
    )
  }
}

export {
  SelectReportTemplateCategoryDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/selectReportTemplateCategory/dialog.js